import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=caa428b6&scoped=true&"
import script from "./SiteNav.vue?vue&type=script&lang=js&"
export * from "./SiteNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa428b6",
  null
  
)

export default component.exports